import React from 'react';
import { CheckIcon, ShieldIcon, CreditCardIcon, PackageIcon } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
import { buildHotmartUrl } from '../utils/hotmartTracking';
export function CtaSection() {
  const basePrice = 10299;
  // Handle add to cart event
  const handleAddToCart = () => {
    trackPixelEvent('AddToCart', {
      value: basePrice,
      currency: 'ARS',
      content_name: 'Método Milhojas Perfecta',
      content_ids: ['M101869446L'],
      content_type: 'product'
    });
  };
  return <section className="py-12 mb-12" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-108">
          Lo Mejor de Todo
        </h2>
        <p className="text-lg text-center text-gray-700 mb-8" data-id="element-109">
          Llévate Hoy Mismo la Receta Completa
        </p>
        <p className="text-center text-gray-700 mb-8" data-id="element-110">
          No necesitas experiencia previa en pastelería. Con el Método Milhojas
          Perfecta, vas a seguir un sistema tan claro y probado que es imposible
          fallar.
        </p>
        <p className="text-center text-gray-700 mb-8" data-id="element-111">
          Haz clic en el botón de abajo y recibe acceso inmediato al curso
          completo.
        </p>
        <div className="text-center mb-8" data-id="element-112">
          <div className="flex justify-center gap-4 flex-wrap" data-id="element-113">
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-114">
              <PackageIcon size={14} className="text-amber-600" data-id="element-115" />
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-116">
              <CheckIcon size={14} className="text-amber-600" data-id="element-117" />
              Sin experiencia previa
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-118">
              <ShieldIcon size={14} className="text-amber-600" data-id="element-119" />
              Resultados garantizados
            </span>
          </div>
        </div>
        <div className="bg-amber-50 p-4 rounded-lg text-center" data-id="element-120">
          <a href={buildHotmartUrl('https://pay.hotmart.com/M104730533B?checkoutMode=10')} onClick={handleAddToCart} className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors mb-4 animate-heartbeat" data-id="element-121">
            Comprar Ahora
          </a>
          <div className="flex justify-center gap-4 flex-wrap" data-id="element-122">
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-123">
              <CreditCardIcon size={14} className="text-amber-600" data-id="element-124" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-125">
              <PackageIcon size={14} className="text-amber-600" data-id="element-126" />
              Entrega inmediata
            </span>
            <span className="flex items-center gap-1 text-sm text-gray-700" data-id="element-127">
              <ShieldIcon size={14} className="text-amber-600" data-id="element-128" />
              Garantía de satisfacción
            </span>
          </div>
        </div>
      </div>
    </section>;
}